/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForForTclItsm extends models.GovernanceConfigurationBaseForItsm {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForForTclItsm.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForForTclItsm>): GovernanceConfigurationBaseForForTclItsm {
        let obj = Object.assign(new GovernanceConfigurationBaseForForTclItsm(), model);
        GovernanceConfigurationBaseForForTclItsm.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForForTclItsm>): GovernanceConfigurationBaseForForTclItsm {
        if (!model) return null;
        return GovernanceConfigurationBaseForForTclItsm.newInstance(<GovernanceConfigurationBaseForForTclItsm> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForForTclItsm) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForForTclItsm.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForForTclItsm): boolean {
        if (models.GovernanceConfigurationBaseForItsm.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForForTclItsm.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
